import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import "../styles/userprofile.css";

export default function UserProfile() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // your API base URL
  const navigate = useNavigate();

  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch logged-in user from localStorage
    const loggedInUser = JSON.parse(localStorage.getItem("user"));

    // If no logged-in user, redirect to login
    if (!loggedInUser || !loggedInUser.user_id) {
      navigate("/login");
      return;
    }

    // Fetch user details from API
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}user_detail.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: loggedInUser.user_id }),
        });

        const data = await response.json();
        console.log(data);
        if (data.head.code === 200 && data.body) {
          setUser({
            name: data.body.user_name || "",
            email: data.body.user_mail || "",
            password: data.body.user_password || "",
            mobile: data.body.user_mobile || "",
          });
        } else {
          alert("Failed to fetch user data.");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        alert("Error fetching user data.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate, API_BASE_URL]);

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Save (update localStorage; you can call API here to update DB)
  const handleSave = async () => {
  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  if (!loggedInUser?.user_id) {
    alert("User not logged in");
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}user_detail_edit.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: loggedInUser.user_id,
        user_name: user.name,
        user_mail: user.email,
        user_mobile: user.mobile,
        user_password: user.password,
      }),
    });

    const data = await response.json();
    console.log("Update response:", data);

    if (data.head?.code === 200) {
      // Update localStorage only after successful API update
      localStorage.setItem(
        "user",
        JSON.stringify({
          user_id: loggedInUser.user_id,
          name: user.name,
          email: user.email,
          mobile: user.mobile,
        })
      );

      alert("Profile updated successfully!");
    } else {
      alert(data.head?.msg || "Failed to update profile");
    }
  } catch (error) {
    console.error("Update error:", error);
    alert("Server error while updating profile");
  }
};

   // Page Loader
  const PageLoader = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#ffffff",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        className="spinner-border"
        role="status"
        style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
      />
      <p className="mt-3 fw-semibold">Loading your Profile...</p>
    </div>
  );
};


  // if (loading) {
  //   return (
  //     <div style={{ textAlign: "center", marginTop: "50px" }}>
  //       Loading user data...
  //     </div>
  //   );
  // }

  return (
    <> {loading && <PageLoader />}
    
    <div className="user-profile-page mt-5">
      <div className="profile-container shadow-sm">
        <h2 className="profile-title">My Profile</h2>

        <form className="profile-form" onSubmit={(e) => e.preventDefault()}>
          {/* Username */}
          <div className="form-group">
            <label htmlFor="name">Username</label>
            <input
              type="text"
              id="name"
              name="name"
              value={user.name}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your username"
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={user.email}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your email"
            />
          </div>

          {/* Password */}
          <div className="form-group position-relative">
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={user.password}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your password"
            />
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
          </div>

          {/* Mobile Number */}
          <div className="form-group">
            <label htmlFor="mobile">Mobile Number</label>
            <input
              type="text"
              id="mobile"
              name="mobile"
              value={user.mobile}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your mobile number"
            />
          </div>

          {/* Save Button */}
          <button
            type="submit"
            className="btn btn-warning btn-save mt-3 fw-bold"
            onClick={handleSave}
          >
            Save Changes
          </button>
        </form>
      </div>
    </div>
    </>
  );
}
